import React from "react";

import ChangePassword from "./ChangePassword";
import DeactivateAccount from "./DeactivateAccount";
import LinkAccounts from "./LinkAccounts";

const Account = () => {
  return (
    <>
      <div className="mb-16 flex flex-col gap-y-2.5">
        <ChangePassword />
        <LinkAccounts />
        <DeactivateAccount />
      </div>
    </>
  );
};

export default Account;
